import { isMobile } from "../../helpers/functions/isMobile";

export const sidebarTourSteps = [
  {
    target: "body",
    content:
      "Welcome to your dashboard! This interactive tour will guide you through the main navigation features. Click 'Next' to begin.",
    disableBeacon: true,
    placement: "center",
  },
  {
    target: ".hamburger-menu-icon",
    content:
      "click this hamburger icon to open the navigation menu and access all features.",
    placement: "bottom",
    disableBeacon: false,
    spotlightClicks: true,
    hideFooter: false,
    showOnlyWhen: () => isMobile, // Show only on mobile/tablet
  },
  {
    target: isMobile ? ".icon-sidebar-item-0" : ".icon-sidebar",
    content:
      "This is your main navigation menu. Click on any icon to explore different sections. Try clicking on one now!",
    placement: isMobile ? "top" : "right",
    disableBeacon: false,
    spotlightClicks: true,
    hideFooter: false,
  },
  {
    target: isMobile ? ".submenu-sidebar-item-0" : ".submenu-sidebar",
    content:
      "When you select a main menu, its submenu appears here. Click on any submenu item to navigate.",
    placement: isMobile ? "top" : "right",
    disableBeacon: false,
    spotlightClicks: true,
  },
  {
    target: ".tour-guide-button",
    content:
      "You can restart this tour anytime by clicking this help button. Click 'Finish' to end the tour!",
    placement: "bottom",
    disableBeacon: false,
  },
];

// Function to filter steps based on screen size
export const getResponsiveTourSteps = () => {
  return sidebarTourSteps.filter((step) => {
    if (step.showOnlyWhen) {
      return step.showOnlyWhen();
    }
    return true;
  });
};

export const tourStyles = {
  options: {
    arrowColor: "#fff",
    backgroundColor: "#fff",
    overlayColor: "rgba(0, 0, 0, 0.7)",
    primaryColor: "#0d6efd",
    textColor: "#333",
    width: window.innerWidth < 768 ? 320 : 400,
    zIndex: 10000,
    beaconSize: 36,
  },
  buttonNext: {
    backgroundColor: "#0d6efd",
    borderRadius: "6px",
    color: "#fff",
    padding: "10px 20px",
    fontSize: "14px",
    fontWeight: "600",
  },
  buttonBack: {
    color: "#6c757d",
    marginRight: "12px",
    fontWeight: "600",
  },
  buttonSkip: {
    color: "#dc3545",
    fontWeight: "600",
  },
  tooltip: {
    borderRadius: "12px",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
    padding: window.innerWidth < 768 ? "15px" : "20px",
  },
  tooltipContainer: {
    textAlign: "left",
  },
  tooltipContent: {
    padding: "10px 0",
    fontSize: window.innerWidth < 768 ? "14px" : "15px",
    lineHeight: "1.6",
  },
  tooltipTitle: {
    fontSize: window.innerWidth < 768 ? "16px" : "18px",
    fontWeight: "700",
    marginBottom: "12px",
    color: "#212529",
  },
  beacon: {
    inner: "#0d6efd",
    outer: "#0d6efd",
  },
  beaconInner: {
    backgroundColor: "#0d6efd",
  },
  beaconOuter: {
    backgroundColor: "rgba(13, 110, 253, 0.2)",
    border: "2px solid #0d6efd",
  },
  spotlight: {
    borderRadius: "8px",
  },
};
